// extracted by mini-css-extract-plugin
export default {"switchWithSublabel":"ContactForm-switchWithSublabel_yI1R6"};